import React from 'react';
import {
  Home as HomeIcon,
  Quiz as SurveysIcon,
  Assessment as ReportsIcon,
  Insights as InsightIcon,
  ManageAccounts as ManageIcon,
  RateReview as AuditIcon,
} from '@mui/icons-material';
import { RoleBasedConfig } from './routeTypes';
import { UserRole } from '@features/authentication/types';
import { commonNavigationItems, commonRoutes } from './commonRoutes';
import { DashboardRoutes } from '@features/dashboard';
import { SurveyRoutes } from '@features/survey';
import { ReportsRoutes } from '@features/reports';
import { InsightRoutes } from '@features/insight';
import { ManageRoutes, ManageRouteGuard } from '@features/manage';
import { SurveyAuditRoutes } from '@features/survey-audit';
import { SurveyInstanceRoutes } from '@features/survey-instance';
import { ProtectedRoute } from '../ProtectedRoute';
import { Navigate } from 'react-router-dom';
import { LecturerManageWrapper } from '@features/subject';

export const lecturerConfig: RoleBasedConfig = {
  navigation: {
    top: [
      {
        label: 'Dashboard',
        href: '/app/dashboard',
        icon: React.createElement(HomeIcon),
      },
      {
        label: 'Surveys',
        href: '/app/surveys',
        icon: React.createElement(SurveysIcon),
      },
      {
        label: 'Audit',
        href: '/app/survey-audits',
        icon: React.createElement(AuditIcon),
      },
      {
        label: 'Reports',
        href: '/app/reports',
        icon: React.createElement(ReportsIcon),
      },
      {
        label: 'Insight',
        href: '/app/insight',
        icon: React.createElement(InsightIcon),
      },
      {
        label: 'Manage',
        href: '/app/manage',
        icon: React.createElement(ManageIcon),
      },
    ],
    bottom: commonNavigationItems.bottom,
  },
  routes: [
    {
      path: 'dashboard',
      element: React.createElement(ProtectedRoute, null, React.createElement(DashboardRoutes)),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: '',
      element: React.createElement(Navigate, { to: 'dashboard', replace: true }),
    },
    {
      path: 'surveys/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(SurveyRoutes)),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: 'surveys/:surveyId/instance/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(SurveyInstanceRoutes)),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: 'survey-audits/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(SurveyAuditRoutes)),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: 'reports/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(ReportsRoutes)),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: 'insight/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(InsightRoutes)),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: 'manage',
      element: React.createElement(
        ProtectedRoute,
        null,
        React.createElement(LecturerManageWrapper)
      ),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    {
      path: 'manage/*',
      element: React.createElement(
        ProtectedRoute,
        null,
        React.createElement(ManageRouteGuard, null, React.createElement(ManageRoutes))
      ),
      protected: true,
      requiredRoles: [UserRole.PROFESSOR],
    },
    ...commonRoutes,
  ],
};
